import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

export default function AddUserIconButton(props) {
	const { tooltipTitle, onClick, status } = props;
	const classes = useStyles();
	return (
		<IconButton className={`${classes.add} ${classes.iconButton}`} disabled={status} onClick={onClick}>
			<Tooltip title={tooltipTitle} aria-label="add">
				<PersonAddIcon />
			</Tooltip>
		</IconButton>
	);
}

const useStyles = makeStyles((theme) => ({
	add: {
		"&:hover": {
			"& svg": {
				fill: "#63B093",
			},
		},
	},
	iconButton: {
		"& svg": {
			fill: theme.palette.primary.main,
		},
	},
}));
